import React from 'react';
import ReactDOM from 'react-dom';

import CareersPageJobBoardTabs from 'components/CareersPageJobBoardTabs';

const CareersPageController = class {
  static mountCareersPageJobBoardTabs = () => {
    ReactDOM.render(
      <CareersPageJobBoardTabs />,
      document.getElementById('careers-page-job-board-tabs-container')
    );
  };

  static init = () => {
    CareersPageController.mountCareersPageJobBoardTabs();
  };
};

export default CareersPageController;
